
import { Component, Prop, Vue } from 'vue-property-decorator';

import UserItem from '../UserItem/index.vue';
import EmptyChat from '@/assets/imgs/chat/EmptyChat.vue';
import { Teacher, Message } from '../../interface';

@Component({
  components: {
    EmptyChat,
    UserItem
  }
})
export default class ChatMessage extends Vue {
  @Prop() private currentUser!: Teacher;
  @Prop() private isWidget!: boolean;

  messageSend = '';
  messages = [
    {
      senderId: 2145147,
      content: 'Oi, tudo bem?',
      id: 1,
      dateSent: '10h32'
    },
    {
      senderId: 2,
      content:
        'Lorem ipsum dolor sit amet consectetur. Justo maecenas netus nulla enim. Egestas lobortis donec mi id tortor aliquet leo est. Faucibus tellus nulla morbi aliquet accumsan vitae varius etiam pellentesque. In malesuada arcu consectetur sit. Euismod tincidunt tempus purus scelerisque luctus commodo consequat nec.',
      id: 2,
      dateSent: '10h32'
    },
    {
      senderId: 2145147,
      content:
        'Lorem ipsum dolor sit amet consectetur. Justo maecenas netus nulla enim. Egestas lobortis donec mi id tortor aliquet leo est. Faucibus tellus nulla morbi aliquet accumsan vitae varius etiam pellentesque. In malesuada arcu consectetur sit. Euismod tincidunt tempus purus scelerisque luctus commodo consequat nec.',
      id: 3,
      dateSent: '10h32'
    },
    {
      senderId: 2,
      content: 'Oi, tudo bem?',
      id: 4,
      dateSent: '10h32'
    }
  ] as Array<Message>;

  get profile() {
    return this.$store.getters.profile;
  }

  async hadleSendMessage() {
    if (this.messageSend.length === 0) {
      return;
    }

    const message = {
      senderId: this.profile.idstudent,
      content: this.messageSend,
      dateSent: new Date().toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
      })
    } as Message;

    this.messages.push(message);
    this.messageSend = '';
    this.$nextTick(() => {
      const chat = this.$el.querySelector('.messages__student-chat');
      if (chat) {
        chat.scrollTop = chat.scrollHeight;
      }
    });
  }

  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' && event.shiftKey) {
      event.preventDefault();

      // Posição atual do cursor
      const textarea = event.target as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;

      // Insere quebra de linha na posição do cursor
      this.messageSend = `${this.messageSend.substring(0, start)}\n${this.messageSend.substring(end)}`;

      // Atualiza a posição do cursor para depois da quebra de linha
      this.$nextTick(() => {
        if (textarea) {
          textarea.selectionStart = start + 1;
          textarea.selectionEnd = start + 1;
        }
      });
    } else if (event.key === 'Enter') {
      event.preventDefault();
      this.hadleSendMessage();
    }
  }
}
